(function () {
  'use strict';

  angular
      .module('tfc.retailer.Pagination')
      .directive('tfcPagination', tfcPagination);

  function tfcPagination(){
    return {
      restrict: 'E',
      templateUrl : 'Util/Pagination/Pagination.tmpl.html',
      scope:{
        filteredCount: "=",
        pageSize : "=",
        currentPage: "=",
        paginationFunc: "&",
        maxSize: "="
      }
    }
  }

})();